// Shared functions used across multiple modules
import { clearAllTables } from "./utils/ui_utils";

export const renderFirstInstructions = function () {
  const welcomeMessageWindow = document.querySelector(
    ".welcome-message-window",
  );
  const markup = `
 <div class="welcome-message"> <h3 class='introduction'>PRIMA DI INSERIRE UN NUOVO PIANO, è consigliato verificare che i seguenti elementi siano presenti nelle anagrafiche:</h3>
  <ol class='introduction-list'>
  <li>La coltura;</li>
  <li>L'azienda;</li>
  <li>Il settore;</li>
  <li>I concimi di fondo da utilizzare ed il relativo prezzo per l'azienda di riferimento;</li>
  <li>I fertirriganti da utilizzare ed il relativo prezzo per l'azienda di riferimento;</li>
  </ol>
  <p class='introduction-paragraph'>Se qualche elemento non è presente in anagrafica, aggiungerlo e poi procedere con l'inserimento di un nuovo piano.</p></div>`;
  welcomeMessageWindow.innerHTML = "";
  welcomeMessageWindow.insertAdjacentHTML("afterbegin", markup);
};

export const renderMenu = function () {
  const markup = `
  <h3 class='sub-menu-header'>GESTIONE ANAGRAFICHE</h3>
  <div class="sub-menu records_menu">
      <button class="btn menu__btn crops_btn">
        <img src="/icons/menu-crop1.jpg" alt="crops" class="menu__btn-icon">
        <p class="menu__btn-title">Gestione Colture</p>
        <p class="menu__btn-description">Gestisci le colture ed i loro fabbisogni</p>
      </button>
      <button class="btn menu__btn company_btn">
        <img src="/icons/menu-company.jpg" alt="company" class="menu__btn-icon">
        <p class="menu__btn-title">Gestione Aziende</p>
        <p class="menu__btn-description">Gestisci le aziende ed i loro dati</p>
      </button>
      <button class="btn menu__btn sectors_btn">
        <img src="/icons/menu-sector.jpg" alt="sectors" class="menu__btn-icon">
        <p class="menu__btn-title">Gestione Settori</p>
        <p class="menu__btn-description">Gestisci i settori e le loro specifiche</p>
      </button>
  </div>
  <h3 class='sub-menu-header'>CATALOGO PRODOTTI</h3>
  <div class="sub-menu products_menu">
      <button class="btn menu__btn products_btn">
        <img src="/icons/menu-product1.jpg" alt="product" class="menu__btn-icon">
        <p class="menu__btn-title">Catalogo Concimi di Fondo</p>
        <p class="menu__btn-description">Database dei concimi di fondo e relative specifiche</p>
      </button>
      <button class="btn menu__btn fertiProducts_btn">
        <img src="/icons/menu-fertiproduct2.jpg" alt="fertiproduct" class="menu__btn-icon">
        <p class="menu__btn-title">Catalogo Prodotti Fertirriganti</p>
        <p class="menu__btn-description">Database dei prodotti fertirriganti e relative specifiche</p>
      </button>
  </div>
  <h3 class='sub-menu-header'>PIANIFICAZIONE OTTIMIZZATA</h3>
  <div class="sub-menu plans_menu">
      <button class="btn menu__btn new-plan_btn">
        <img src="/icons/menu-newPlan1.jpg" alt="newPlan" class="menu__btn-icon">
        <p class="menu__btn-title">Nuovo Piano</p>
        <p class="menu__btn-description">Crea un nuovo piano personalizzato</p>
      </button>
      <button class="btn menu__btn open-plan_btn">
        <img src="/icons/menu-openPlan.jpg" alt="openPlan" class="menu__btn-icon">
        <p class="menu__btn-title">Apri Piano</p>
        <p class="menu__btn-description">Visualizza un piano esistente</p>
      </button>
  </div>
  `;

  const menuTag = document.querySelector(".menu-tag");
  menuTag.insertAdjacentHTML("afterbegin", markup);
};

export const hideMenu = function () {
  const menuTag = document.querySelector(".menu-tag");
  //const sidebarMenu = document.querySelector(".menu-sidebar");
  menuTag.innerHTML = "";
  const markup =
    '<button class="sidebar_menu__btn" id="sidebar_menu_btn"><img src="/icons/sidebar-menu-logo1.jpg" alt="sidebar-menu" class="menu__short-btn-icon sidebar_menu_logo"><p class="sidebarmenu__btn-title">Ritorna al menù</p></button>';
  menuTag.insertAdjacentHTML("afterbegin", markup);

  /*<p class="sidebarmenu__btn-description">Scegli la tua nuova attività</p>*/

  //const sidebarMenu = document.querySelector(".menu-sidebar");
  //sidebarMenu.style.backgroundColor = " #f3f3f3";
  //sidebarMenu.style.boxShadow = "none";

  const sidebarMenuBtn = document.getElementById("sidebar_menu_btn");
  sidebarMenuBtn.addEventListener("click", function () {
    console.log("sidebar menu btn clicked");
    //companyWindow.innerHTML = "";
    clearAllTables(false);
    sidebarMenuBtn.remove();

    renderMenu();

    //selectMenu(currentAccount);
  });
};
